/**
 * 接口定义
 */
import * as APIS from '../config.js'
// import QS from 'qs'
import Axios from 'axios'

// import * as CONSTANT from '@/config/const.config.js'

// 获得底部数据
export function getPcBottom () {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'bottomData'
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得金牌教师
export function getGoldTeacher () {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'teacher'
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得所有课程信息
export function getCourse () {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'pcCourseSet'
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得明星学员
export function getStar () {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'starStudents'
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得今日推荐
export function getRecommend () {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'recommendCourseSet'
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得轮播
export function getCarousel () {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'carousel',
        flag: 'pc'
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得轮播位置2个图片的广告位
export function getCategoryRecommendCourseSet (id) {
  const requestUrl = APIS.apibase + APIS.v3 + '/index'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl, {
      params: {
        type: 'categoryRecommendCourseSet',
        categoryId: id
      }
    }).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得导航数据
export function getNavigation (id) {
  const requestUrl = APIS.apibase + APIS.v3 + '/navigation'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}

// 获得分类列表
export function getCategoryList (id) {
  const requestUrl = APIS.apibase + APIS.v3 + '/categorys/course'
  return new Promise((resolve, reject) => {
    Axios.get(requestUrl).then(response => {
      const data = response.data
      resolve(data)
    }).catch(error => {
      const response = error.response
      const message = (response.data && response.data.error && response.data.error.message) || '网络异常'
      reject(new Error(message))
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/api/modules/home.js